import { useQuery } from '@tanstack/react-query';

import { studentApi } from '@/api';
import { ErrorState, LoadingState } from '@/components/ui';
import { errorMessage } from '@/hooks/useApiError';
import { PortfolioView } from '@/pages/PublicPortfolioPage';

/**
 * The student's own profile as a company would read it: the shareable page's
 * layout, whether or not sharing is on. Fetched fresh each time it opens, so
 * an edit made a moment ago is already there.
 */
export function ProfileView({ actions }) {
  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: ['student-portfolio-view'],
    queryFn: studentApi.getPortfolioView,
    staleTime: 0,
  });

  if (isPending) return <LoadingState label="Loading your profile…" />;
  if (isError) {
    return <ErrorState message={errorMessage(error)} onRetry={() => void refetch()} />;
  }
  return <PortfolioView data={data} actions={actions} className="" />;
}
